import styled from "styled-components";

export const StyledHeader = styled.header`
  text-align: left;  // Left-aligns all content in the header
  padding: 1.75vw 3vw;  // Adds some padding around the content
  position: absolute;
  top: 0vw;
  left: 0vw;
  font-size: 1.2vw;
  
  @media (max-width: 1000px) {
    font-size: 12px;
  }

  @media (max-width: 600px) {
    padding: 5vw 0vw;
    width: 100vw;
    text-align: center;
    font-size: 4.5vw;
  }
`;

export const MLHLogo = styled.a`
  display: block;
  max-width: 100px;
  min-width: 40px;
  position: fixed;
  right: 25px;
  top: 0;
  width: 10%;
  z-index: 10000;

  @media (max-width: 600px) {
    right: 10px;
    display: none;
  }
`